<div class="dataset-card">
    <div class="dataset-card__head">
        <!-- <span class="dataset-card__label">Dataset {{ index + 1 }}</span> -->
        <span class="dataset-card__badge"
            [class.dataset-card__badge--primary]="dataset.isPrimary"
            [class.dataset-card__badge--join]="!dataset.isPrimary">
            {{ dataset.isPrimary ? 'Primary dataset' : 'Join required' }}
        </span>
    </div>

    <p class="dataset-card__description">
        {{ dataset.isPrimary
            ? ''
            : 'Configure this table used to enrich or join another dataset.' }}
    </p>

    <div class="dataset-card__fields">
        <div class="dataset-card__field">
            <label class="dataset-card__field-label">Dataset name <span class="dataset-card__required">*</span></label>
            <input type="text" class="dataset-card__input" placeholder="Enter dataset name"
                [(ngModel)]="dataset.name" />
        </div>

        <div class="dataset-card__field">
            <label class="dataset-card__field-label">Select Datasource <span class="dataset-card__required">*</span></label>
            <mat-select class="dataset-card__select" panelClass="dataset-card__select-panel"
                placeholder="Select a datasource" [(ngModel)]="dataset.table_name"
                (selectionChange)="onDatasourceSelected($event.value)">
                <mat-option *ngFor="let option of datasourceOptions" [value]="option.table_name"
                    [disabled]="usedTableNames.includes(option.table_name)">
                    {{ option.dataset_name }}
                </mat-option>
            </mat-select>
        </div>
        <div class="dataset-card__field">
            <label class="dataset-card__field-label">Columns</label>
            <div class="dataset-card__group-btn">
                <button type="button" class="dataset-card__manage-btn" [disabled]="!dataset.table_name"
                    (click)="onToggleManageColumns()">
                    <mat-icon aria-hidden="true">view_column</mat-icon>
                    <span>{{ dataset.manageColumnsOpen ? 'Hide columns' : 'Manage columns' }}</span>
                </button>
                <button type="button" class="dataset-card__schema-btn" *ngIf="canRemove"
                    [class.dataset-card__schema-btn--active]="dataset.relationshipsOpen"
                    [disabled]="!dataset.table_name || !availableJoinTargets.length"
                    (click)="onToggleRelationships()" aria-label="Establish relationships">
                    <mat-icon aria-hidden="true">schema</mat-icon>
                </button>
                <button type="button" class="dataset-card__delete-btn" *ngIf="canRemove" (click)="remove.emit()"
                    aria-label="Remove dataset">
                    <mat-icon aria-hidden="true">delete_outline</mat-icon>
                </button>
            </div>
        </div>
    </div>

    <div class="dataset-card__columns-bar" [hidden]="!dataset.manageColumnsOpen">
        <div class="dataset-card__columns-info">
            <span class="dataset-card__columns-title">
                {{ dataset.manageColumnsOpen ? 'Column management' : 'Columns' }}
            </span>
            <span class="dataset-card__columns-subtitle" *ngIf="dataset.manageColumnsOpen">
                Review the columns included in Dataset {{ index + 1 }} and define how each needs to be aggregated.
            </span>
        </div>

        <div class="dataset-card__columns-actions">
            <label class="dataset-card__use-all" *ngIf="dataset.manageColumnsOpen && dataset.columns.length">
                <input type="checkbox" [checked]="allColumnsSelected" (change)="onUseAllColumns()" />
                <span>Use all columns</span>
            </label>
            <span class="dataset-card__columns-count" *ngIf="dataset.manageColumnsOpen && dataset.columns.length">
                {{ dataset.columns.length }} COLUMN{{ dataset.columns.length === 1 ? '' : 'S' }}
            </span>
            <button *ngIf="hasReportAdminRole" type="button" class="dataset-card__add-calculated-btn techops-global-button" [disabled]="!dataset.table_name"
                (click)="onOpenAddCalculatedColumn()">
                Add custom column
            </button>
        </div>
    </div>

    <div class="dataset-card__column-table" *ngIf="dataset.manageColumnsOpen">
        <app-dataset-column-table [columns]="dataset.columns" [loading]="dataset.columnsLoading"></app-dataset-column-table>
    </div>

    <div class="dataset-card__relationships" *ngIf="canRemove && dataset.relationshipsOpen">
        <div class="dataset-card__relationships-head">
            <div class="dataset-card__columns-info">
                <span class="dataset-card__columns-title">Established relationships</span>
                <span class="dataset-card__columns-subtitle">Review and extend the current join setup between datasets.</span>
            </div>
            <span class="dataset-card__badge"
                [class.dataset-card__badge--primary]="relationshipsConfigured"
                [class.dataset-card__badge--join]="!relationshipsConfigured">
                {{ relationshipsConfigured ? 'Configured' : 'Join required' }}
            </span>
        </div>

        <div class="dataset-card__join" *ngFor="let join of dataset.joins; let j = index; trackBy: trackByJoinId">
            <div class="dataset-card__join-head">
                <span class="dataset-card__join-title">Join {{ j + 1 }}</span>
                <span class="dataset-card__badge"
                    [class.dataset-card__badge--primary]="isJoinConfigured(join)"
                    [class.dataset-card__badge--join]="!isJoinConfigured(join)">
                    {{ isJoinConfigured(join) ? 'Configured' : 'Join required' }}
                </span>
                <button type="button" class="dataset-card__join-remove" *ngIf="dataset.joins.length > 1"
                    (click)="onRemoveJoin(join)" aria-label="Remove join">
                    <mat-icon aria-hidden="true">close</mat-icon>
                </button>
            </div>

            <div class="dataset-card__join-fields">
                <div class="dataset-card__field">
                    <label class="dataset-card__field-label">Dataset</label>
                    <mat-select class="dataset-card__select" placeholder="Select a dataset"
                        [(ngModel)]="join.targetDatasetId" (selectionChange)="onJoinTargetChange(join)">
                        <mat-option *ngFor="let target of availableJoinTargets" [value]="target.id">
                            {{ target.table_name }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="dataset-card__field">
                    <label class="dataset-card__field-label">
                        <!-- <mat-icon aria-hidden="true">join_inner</mat-icon> -->
                        Join type
                    </label>
                    <mat-select class="dataset-card__select" placeholder="Select join type" [(ngModel)]="join.joinType"
                        [disabled]="!join.targetDatasetId">
                        <mat-option *ngFor="let option of getJoinTypeOptions(join)" [value]="option.value">{{ option.label }}</mat-option>
                    </mat-select>
                </div>
            </div>

            <div class="dataset-card__mapping">
                <div class="dataset-card__mapping-head">
                    <span>Column mapping</span>
                </div>
                <div class="dataset-card__mapping-guide">
                    {{ getDatasetById(join.targetDatasetId)?.table_name }} -&gt; {{ dataset.table_name }}
                </div>

                <ng-container *ngFor="let mapping of join.columnMappings; trackBy: trackByMappingId">
                <div class="dataset-card__mapping-row">
                    <div class="dataset-card__field">
                        <label class="dataset-card__field-label">Left column</label>
                        <mat-select class="dataset-card__select" panelClass="dataset-card__select-panel"
                            placeholder="Select column" [(ngModel)]="mapping.leftColumn"
                            (selectionChange)="onLeftColumnChange(join, mapping)">
                            <div class="dataset-card__select-search" (click)="$event.stopPropagation()">
                                <input type="text" placeholder="Search column" [(ngModel)]="mapping.leftColumnSearch"
                                    (keydown)="$event.stopPropagation()" />
                            </div>
                            <mat-option
                                *ngFor="let column of filterColumns(getDatasetById(join.targetDatasetId)?.columns, mapping.leftColumnSearch)"
                                [value]="column.key">
                                {{ column.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="dataset-card__field">
                        <label class="dataset-card__field-label">Right column</label>
                        <mat-select class="dataset-card__select" panelClass="dataset-card__select-panel"
                            placeholder="Select column" [(ngModel)]="mapping.rightColumn"
                            (selectionChange)="onRightColumnChange(join, mapping)">
                            <div class="dataset-card__select-search" (click)="$event.stopPropagation()">
                                <input type="text" placeholder="Search column" [(ngModel)]="mapping.rightColumnSearch"
                                    (keydown)="$event.stopPropagation()" />
                            </div>
                            <mat-option *ngFor="let column of filterColumns(dataset.columns, mapping.rightColumnSearch)"
                                [value]="column.key">
                                {{ column.name }}
                            </mat-option>
                        </mat-select>
                    </div>
                    <button type="button" class="dataset-card__mapping-remove" *ngIf="join.columnMappings.length > 1"
                        (click)="onRemoveColumnMapping(join, mapping)" aria-label="Remove column mapping">
                        <mat-icon aria-hidden="true">close</mat-icon>
                    </button>
                </div>
                <div class="dataset-card__mapping-error" *ngIf="getMappingError(join, mapping) as mappingError">
                    {{ mappingError }}
                </div>
                </ng-container>

                <button type="button" class="dataset-card__add-mapping" (click)="onAddColumnMapping(join)">
                    <mat-icon aria-hidden="true">add</mat-icon>
                    <span>Add column mapping</span>
                </button>
            </div>
        </div>

        <button type="button" class="dataset-card__add-join" (click)="onAddJoin()"
            [disabled]="!availableJoinTargets.length">
            <mat-icon aria-hidden="true">add</mat-icon>
            <span>Add join</span>
        </button>
    </div>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #calculatedColumnModal
    class="modal-demo add-calculated-column-popup" (closeModal)="onCloseAddCalculatedColumn()">
    <ng-container class="app-modal-header">
        <div class="add-calculated-column-popup__heading">
            <span class="add-calculated-column-popup__title">Create calculated column</span>
            <!-- <span class="add-calculated-column-popup__subtitle">
                Define a new column using an expression and choose source columns from the selected dataset.
            </span> -->
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <div class="add-calculated-column">
            <div class="add-calculated-column__field">
                <label class="add-calculated-column__label">Column name <span class="dataset-card__required">*</span></label>
                <input type="text" class="add-calculated-column__input" placeholder="Enter column name"
                    [(ngModel)]="calculatedColumnName" (ngModelChange)="onCalculatedColumnNameChange()" />
            </div>

            <div class="add-calculated-column__field">
                <label class="add-calculated-column__label">Formula / expression <span class="dataset-card__required">*</span></label>
                <div class="add-calculated-column__expression-row">
                    <input type="text" class="add-calculated-column__input" placeholder="e.g. SUM(A.Curr_Year_FC_Curr_Charges) - SUM(A.pending_charges)"
                        [(ngModel)]="calculatedColumnExpression" (ngModelChange)="onCalculatedColumnExpressionChange()" />
                    <button type="button" class="add-calculated-column__insert-btn" (click)="onToggleColumnPicker()">
                        Select column
                    </button>
                </div>


                <div class="add-calculated-column__picker" *ngIf="calculatedColumnPickerOpen">
                    <div class="add-calculated-column__picker-list">
                        <label class="add-calculated-column__picker-option" *ngFor="let column of dataset.columns">
                            <input type="checkbox" [checked]="isColumnPicked(column)" (change)="onToggleColumnPick(column)" />
                            <span>{{ column.name }}</span>
                        </label>
                        <div class="add-calculated-column__picker-empty" *ngIf="!dataset.columns.length">
                            No columns available for this dataset yet.
                        </div>
                    </div>
                    <button type="button" class="add-calculated-column__picker-insert" (click)="onInsertSelectedColumns()">
                        Insert selected
                    </button>
                </div>
            </div>

            <div class="add-calculated-column__error" *ngIf="calculatedColumnNameError || calculatedColumnExpressionError">
                <p class="add-calculated-column__error-title" *ngIf="calculatedColumnNameError">{{ calculatedColumnNameError }}</p>
                <p *ngIf="calculatedColumnExpressionError" class="add-calculated-column__error-title">{{ calculatedColumnExpressionError }}</p>
                
            </div>
        </div>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="add-calculated-column-popup__footer">
            <button type="button" class="add-calculated-column-popup__btn add-calculated-column-popup__btn--secondary"
                (click)="onCloseAddCalculatedColumn()">
                Cancel
            </button>
            <button type="button" class="add-calculated-column-popup__btn add-calculated-column-popup__btn--primary"
                [disabled]="!canAddCalculatedColumn" (click)="onAddCalculatedColumn()">
                Add column
            </button>
        </div>
    </ng-container>
</app-modal>
